
  <h2 class="secret__title secret__title--add">
    Add New Password
  </h2>

  <secret-form-container
    class="secret-form-component"
    [class.secret-form-component--is-active]="secretAnimated"
  ></secret-form-container>
  